<template>
  <v-app>
    <div class="min-h-full">
      <PublicHeader />
      <main class="flex-1">
        <slot />
      </main>
      <TheFooter />
      <TheLoader />
    </div>
  </v-app>
</template>

<script setup>
import TheFooter from "~/components/TheFooter.vue";
import TheLoader from "~/components/TheLoader.vue";
import PublicHeader from "~/components/PublicHeader.vue";
useHead({
  htmlAttrs: {
    class: "h-full bg-white",
  },
  bodyAttrs: {
    class: "h-full font-sans",
  },
  link: [{ rel: "stylesheet", href: "https://rsms.me/inter/inter.css" }],
});
</script>
